/* eslint-disable react-hooks/exhaustive-deps */
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row, Table, Typography } from 'antd';
import { employeeMappingApi } from 'Api/employeeMapping';
import Ellipse from 'components/Global/Ellipse';
import useDebounce from 'components/Global/Hooks/UseDebounce';
import SearchComponent from 'components/Global/SearchComponent';
import SelectDropdown from 'components/Global/SelectDropdown';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { formatDate, invalidText, toastText } from 'utils/utils';
import { fetchConstantDropdownAction } from '../../../redux/actions/constantDropdownAction';
import styles from './index.module.scss';
import { PermissionContext } from 'components/Global/AuthLayout';
import './index.scss';
import {
	getAccessibleBranchForUser,
	getSupervisorsBranches,
} from 'Api/masters/branch-code';
const { Column } = Table;

interface DropdownOption {
	label: string;
	value: string;
}

const MappingTable = () => {
	const dispatch = useDispatch<AppDispatch>();
	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
	const [selectedMappingKeys, setSelectedMappingKeys] = useState<React.Key[]>(
		[]
	);
	const [statusFilterValue, setStatusFilterValue] = useState('');
	const [branchId, setBranchId] = useState<any>('');
	const [currentBranchId, setCurrentBranchId] = useState<any>('');
	const [jobGradeId, setJobGradeId] = useState<any>('');
	const [availableEmployees, setAvailableEmployees] = useState<any[]>([]);
	const [currentMappings, setCurrentMappings] = useState<any[]>([]);
	const [loadingAvailable, setLoadingAvailable] = useState(false);
	const [loadingMappings, setLoadingMappings] = useState(false);
	const [isAssignLoading, setIsAssignLoading] = useState(false);
	const [attendanceSheetLoading, setAttendanceSheetLoading] = useState(false);
	const [isSupervisorsLoading, setIsSupervisorsLoading] = useState(false);
	const [supervisorOptions, setSupervisorOptions] = useState<any[]>([]);
	const [isRemoveBulkLoading, setIsRemoveBulkLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [totalRecords, setTotalRecords] = useState(0);
	const [searchAvailableText, setSearchAvailableText] = useState('');
	const [removingRowId, setRemovingRowId] = useState<React.Key | null>(null);
	const [availableCurrentPage, setAvailableCurrentPage] = useState(1);
	const [availablePageSize, setAvailablePageSize] = useState(100);
	const [availableTotalRecords, setAvailableTotalRecords] = useState(0);
	const debouncedSearchValue = useDebounce(searchText, 500);
	const debouncedSearchAvailableValue = useDebounce(searchAvailableText, 500);
	const [accessibleBranches, setAccessibleBranches] = useState<
		DropdownOption[]
	>([]);
	const [isBranchesLoading, setIsBranchesLoading] = useState<boolean>(false);

	const permissionContext = useContext(PermissionContext);
	const isAdd = permissionContext.allowedPermissions.includes(
		'Add_Employee_Mapping'
	);
	const isDelete = permissionContext.allowedPermissions.includes(
		'Delete_Employee_Mapping'
	);

	const handleSearch = (value: string) => {
		setSearchText(value);
		setCurrentPage(1);
	};

	const handleSearchApi = async (value: string) => {
		//search api
	};

	const handleSearchForAvailableEmp = (value: string) => {
		setSearchAvailableText(value);

		setAvailableCurrentPage(1);
	};

	const handleSearchForAvailableEmpApi = async (value: string) => {
		//search api
	};

	const { isLoading: dropdownOptionsLoading } = useSelector(
		(state: any) => state.constantDropdown
	);
	const dropdownOptions = useSelector(
		(state: any) => state.constantDropdown.data
	);

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	const handleStatusFilter = (value: string | number | string[]) => {
		if (typeof value === 'string') {
			// Proceed as before
			setBranchId(null);
			setCurrentBranchId(null);
			setStatusFilterValue(value);
		}
	};

	const fetchAvailableEmployees = async (preserveSelection = false) => {
		if (!statusFilterValue) {
			return;
		}
		if (!preserveSelection) {
			setSelectedRowKeys([]);
			setSelectedMappingKeys([]);
		}
		setLoadingAvailable(true);
		try {
			const res = await employeeMappingApi.getAvailableEmployees({
				supervisorId: statusFilterValue,
				branchId,
				search: debouncedSearchAvailableValue,
				jobGradeId,
				page: availableCurrentPage,
				pageSize: availablePageSize,
			});
			setAvailableEmployees(res?.data.data || []);
			setAvailableTotalRecords(res?.data.totalRecords || 0);
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				'Failed to fetch available employees';
			toastText(message, 'error');
		} finally {
			setLoadingAvailable(false);
		}
	};
	const fetchCurrentMappings = async (preserveSelection = false) => {
		if (!statusFilterValue) return;

		if (!preserveSelection) {
			setSelectedRowKeys([]);
			setSelectedMappingKeys([]);
		}

		setLoadingMappings(true);
		try {
			const res = await employeeMappingApi.getAllMappedEmployees({
				supervisorId: statusFilterValue,
				branchId: currentBranchId, // ✅ use separate value
				search: debouncedSearchValue,
				jobGradeId,
				page: currentPage,
				pageSize: pageSize,
			});
			setCurrentMappings(res?.data.data || []);
			setTotalRecords(res?.data.totalRecords || 0);
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				'Failed to fetch current mappings';
		} finally {
			setLoadingMappings(false);
		}
	};

	const handleAssignSelected = async () => {
		if (!statusFilterValue || selectedRowKeys.length === 0) {
			toastText(
				'Please select supervisor and employees to assign.',
				'error'
			);
			return;
		}
		setIsAssignLoading(true);
		try {
			await employeeMappingApi.createEmployeeMapping({
				supervisorId: statusFilterValue,
				employeeIds: selectedRowKeys,
			});
			toastText('Employees mapped successfully.', 'success');
			fetchAvailableEmployees();
			fetchCurrentMappings();
		} catch (error: any) {
			let message =
				error?.response?.data?.message || 'Failed to assign employees';
			toastText(message, 'error');
		} finally {
			setIsAssignLoading(false);
		}
	};

	const handleRemoveAllMappings = async () => {
		setIsRemoveBulkLoading(true);
		try {
			await employeeMappingApi.removeEmployeeMapping({
				employeeIds: selectedMappingKeys.map(String),
			});
			toastText('Selected mapped employee has been removed.', 'success');
			setSelectedMappingKeys([]);
			fetchAvailableEmployees();
			fetchCurrentMappings();
		} catch (error: any) {
			let message =
				error?.response?.data?.message || 'Failed to remove mappings';
			toastText(message, 'error');
		} finally {
			setIsRemoveBulkLoading(false);
		}
	};

	const downloadEmployeeMappingCsv = async () => {
		try {
			setAttendanceSheetLoading(true);
			const response =
				await employeeMappingApi.downloadAttendanceSheetForSupervisor(
					statusFilterValue
				);
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/pdf',
				})
			);
			const supervisorName = dropdownOptions?.supervisors?.find(
				(sup: any) => sup.value === statusFilterValue
			)?.label;

			const link = document.createElement('a');
			link.href = url;
			link.setAttribute(
				'download',
				`${supervisorName}-employees-mapping.pdf`
			);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (err) {
			toastText(
				'Something went wrong in downloading excel template',
				'error'
			);
		} finally {
			setAttendanceSheetLoading(false);
		}
	};

	const fetchSupervisors = async () => {
		try {
			setIsSupervisorsLoading(true);
			const res = await employeeMappingApi.getSupervisors();
			const supervisors = res?.data.data.data || [];

			const options = supervisors.map((sup: any) => ({
				label:
					sup.user?.fullName ??
					sup.user?.firstName + ' ' + sup.user?.lastName,
				value: sup.userId,
			}));
			if (supervisors.length > 0) {
				setStatusFilterValue(options[0].value);
			}
			setSupervisorOptions(options);
		} catch (error: any) {
			let message =
				error?.response?.data?.message || 'Failed to fetch supervisors';
			toastText(message, 'error');
		} finally {
			setIsSupervisorsLoading(false);
		}
	};

	useEffect(() => {
		dispatch(fetchConstantDropdownAction({}));
	}, []);

	useEffect(() => {
		fetchSupervisors();
	}, []);

	useEffect(() => {
		fetchCurrentMappings();
	}, [currentBranchId, statusFilterValue, currentPage, pageSize]);

	useEffect(() => {
		fetchAvailableEmployees(true); // Preserve selection during search
	}, [debouncedSearchAvailableValue]);

	useEffect(() => {
		fetchCurrentMappings(true); // Preserve selection during search
	}, [debouncedSearchValue]);

	useEffect(() => {
		fetchAvailableEmployees(false);
	}, [
		branchId,
		jobGradeId,
		availablePageSize,
		availableCurrentPage,
		statusFilterValue,
	]);

	const rowSelection = {
		selectedRowKeys,
		onChange: (selectedKeys: React.Key[]) => {
			setSelectedRowKeys(selectedKeys);
		},
	};

	const mappingRowSelection = {
		selectedRowKeys: selectedMappingKeys,
		onChange: (selectedKeys: React.Key[]) => {
			setSelectedMappingKeys(selectedKeys);
		},
	};

	const tableChangeHandler = (pagination: any, filters: any, sorter: any) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const availableTableChangeHandler = (
		pagination: any,
		filters: any,
		sorter: any
	) => {
		setAvailableTotalRecords(pagination.total);
		setAvailableCurrentPage(pagination.current);
		setAvailablePageSize(pagination.pageSize);
	};

	const fetchAccessibleBranches = async () => {
		if (!statusFilterValue) {
			return;
		}
		try {
			setIsBranchesLoading(true);

			const response = await getSupervisorsBranches(statusFilterValue);

			const branches: DropdownOption[] = response?.data?.data ?? [];

			setAccessibleBranches(branches);
			if (branches.length >= 1) {
				setCurrentBranchId(branches[1].value);
				setBranchId(branches[1].value);
			}
		} catch (error: any) {
			const message =
				error?.response?.data?.message ||
				'Failed to fetch accessible branches';
		} finally {
			setIsBranchesLoading(false);
		}
	};

	useEffect(() => {
		fetchAccessibleBranches();
	}, [statusFilterValue]);

	return (
		<div>
			<Row
				gutter={16}
				style={{
					marginBottom: '12px',
					justifyContent: 'space-between',
				}}
			>
				<Col flex="auto">
					<Row gutter={16}>
						<Col>
							<SelectDropdown
								defaultOption={true}
								defaultLabel="Select Supervisor"
								value={statusFilterValue}
								options={supervisorOptions}
								style={{ width: '250px' }}
								onChange={handleStatusFilter}
								size="large"
								placeholder="Select Supervisor"
								loading={isSupervisorsLoading}
								required={false}
								helperText="supervisor is required"
								disabled={isSupervisorsLoading}
								isError={false}
							/>
						</Col>
						<Col>
							<SelectDropdown
								defaultOption={true}
								defaultLabel="Select Branch"
								placeholder="Select Branch"
								style={{ width: '250px' }}
								options={accessibleBranches}
								value={currentBranchId}
								onChange={(value) => {
									setCurrentBranchId(value);
									setCurrentPage(1);
								}}
								size="large"
								required={false}
								loading={isBranchesLoading}
								disabled={isBranchesLoading}
								helperText="Branch is required"
								isError={false}
							/>
						</Col>
					</Row>
				</Col>
				{statusFilterValue && currentMappings.length > 0 && (
					<Col flex="none">
						<Button
							type="primary"
							onClick={downloadEmployeeMappingCsv}
							loading={attendanceSheetLoading}
						>
							<DownloadOutlined
								style={{ color: '#cccccc', fontSize: '15px' }}
							/>{' '}
							Attendance sheet for{' '}
							{supervisorOptions?.find(
								(sup: any) => sup.value === statusFilterValue
							)?.label || statusFilterValue}
						</Button>
					</Col>
				)}
			</Row>

			<Row gutter={24}>
				<Col span={14}>
					<Card
						title="Current Mappings"
						extra={
							<SearchComponent
								className={styles['supervisor-header-item']}
								placeHolder="Search by code or name..."
								prefixIcon={<SearchOutlined />}
								handleChange={handleSearch}
								handleChangeApi={handleSearchApi}
								value={searchText}
								size="large"
							/>
						}
						styles={{ body: { padding: 0 } }}
						className={styles['table-card']}
					>
						<div className={styles['table-description']}>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<Typography.Text type="secondary">
									Existing supervisor's assignments
								</Typography.Text>
								{isDelete && selectedMappingKeys.length > 0 && (
									<Button
										type="primary"
										danger
										size="small"
										onClick={handleRemoveAllMappings}
										loading={isRemoveBulkLoading}
									>
										Remove{' '}
										{selectedMappingKeys.length === 1
											? 'Mapping'
											: 'Mappings'}{' '}
										({selectedMappingKeys.length})
									</Button>
								)}
							</div>
						</div>
						<div className="assign-supervisor-table">
							<Table
								rowSelection={mappingRowSelection}
								dataSource={currentMappings}
								pagination={{
									total: totalRecords,
									current: currentPage,
									pageSize: pageSize,
									showSizeChanger: false,
									pageSizeOptions: [50, 100, 200, 500],
									showTotal: (total) => (
										<span
											className="color-purple"
											style={{
												marginLeft: '16px',
											}}
										>
											Number of employees in total:{' '}
											{total}
											{total > 1
												? ' mappings'
												: ' mapping'}
										</span>
									),
								}}
								onChange={tableChangeHandler}
								rowKey="id"
								loading={loadingMappings}
								className={styles['custom-table']}
								scroll={{ y: 'calc(100vh - 390px)' }}
								size="middle"
							>
								<Column
									title="Employee Name | Code"
									dataIndex="employee"
									key="employee"
									className="bg-white"
									width={180}
									render={(_: any, record: any) => {
										const fullText = `${record.fullName} | ${record.employeeCode}`;
										return (
											<Ellipse
												maxLength={20}
												message={fullText}
												isTooltip={true}
												key={record.employeeCode}
												tooltipMessage={fullText}
											/>
										);
									}}
								/>

								<Column
									title="Job Grade"
									dataIndex="jobGrade"
									key="jobGrade"
									className="bg-white"
									width={150}
									ellipsis
									render={(_, record: any) => (
										// <Tag color={record.tagColor}>
										<>
											{invalidText(record.jobGrade)
												? '-'
												: record.jobGrade}
										</>
										// </Tag>
									)}
								/>
								<Column
									title="Date"
									dataIndex="createdAt"
									key="createdAt"
									width={120}
									className="bg-white"
									render={(value) => (
										<div>
											{value
												? formatDate(
														value,
														profileData?.companyDateFormat ??
															'DD/MM/YYYY'
												  )
												: '-'}
										</div>
									)}
								/>
								{isDelete && (
									<Column
										title="Actions"
										key="actions"
										width={100}
										className="bg-white"
										render={(_, record: any) => (
											<Button
												type="text"
												danger
												loading={
													removingRowId === record.id
												}
												onClick={async () => {
													setRemovingRowId(record.id);
													try {
														await employeeMappingApi.removeEmployeeMapping(
															{
																employeeIds: [
																	record.id,
																],
															}
														);
														toastText(
															'Mapped employee removed successfully',
															'success'
														);
														fetchAvailableEmployees();
														fetchCurrentMappings();
													} catch (error: any) {
														let message =
															error?.response
																?.data
																?.message ||
															'Failed to remove mapping';
														toastText(
															message,
															'error'
														);
													} finally {
														setRemovingRowId(null);
													}
												}}
											>
												Remove
											</Button>
										)}
									/>
								)}
							</Table>
						</div>
					</Card>
				</Col>

				<Col span={10}>
					<Card
						title="Available Employees"
						extra={
							<SearchComponent
								className={styles['supervisor-header-item']}
								placeHolder="Search by code or name..."
								prefixIcon={<SearchOutlined />}
								handleChange={handleSearchForAvailableEmp}
								handleChangeApi={handleSearchForAvailableEmpApi}
								value={searchAvailableText}
								size="large"
							/>
						}
						className={styles['table-card']}
					>
						<div className={styles['table-description']}>
							<Row gutter={24}>
								<Col span={12}>
									<SelectDropdown
										className={
											styles['supervisor-header-item']
										}
										defaultOption={true}
										defaultLabel="Select Branch"
										placeholder="Select Branch"
										style={{ width: '230px' }}
										options={accessibleBranches}
										value={branchId}
										onChange={(value) => {
											setBranchId(value);
											setAvailableCurrentPage(1);
										}}
										size="middle"
										required={false}
										loading={isBranchesLoading}
										disabled={isBranchesLoading}
										helperText="Branch is required"
										isError={false}
									/>
								</Col>
								<Col span={12}>
									<SelectDropdown
										className={
											styles['supervisor-header-item']
										}
										defaultOption={true}
										defaultLabel="Select Job Grade"
										placeholder="Job Grade"
										style={{ width: '230px' }}
										options={dropdownOptions?.jobGrade}
										value={jobGradeId}
										onChange={(value) => {
											setJobGradeId(value);
											setAvailableCurrentPage(1);
										}}
										size="middle"
										required={false}
										helperText="Job Grade is required"
										loading={dropdownOptionsLoading}
										disabled={dropdownOptionsLoading}
										isError={false}
									/>
								</Col>
							</Row>
						</div>

						<div className="assign-supervisor-table">
							<Table
								rowSelection={rowSelection}
								dataSource={availableEmployees}
								rowKey="id"
								loading={loadingAvailable}
								pagination={{
									total: availableTotalRecords,
									current: availableCurrentPage,
									pageSize: availablePageSize,
									showSizeChanger: false,
									pageSizeOptions: [50, 100, 200, 500],
									showTotal: (total) => (
										<span
											className="color-purple"
											style={{
												marginLeft: '16px',
											}}
										>
											Total : {total} available
											{total > 1
												? ' employees'
												: ' employee'}
										</span>
									),
								}}
								onChange={availableTableChangeHandler}
								className={styles['custom-table']}
								scroll={{ y: 'calc(100vh - 431px )', x: 400 }}
								size="middle"
							>
								<Column
									title="Employee Name | Code"
									key="name"
									width={250}
									className="bg-white"
									render={(_, record: any) => (
										<div>
											{record.fullName} |{' '}
											<span className="color-purple">
												{record.employeeCode}
											</span>
											<div
												style={{
													fontSize: '12px',
													color: '#888',
												}}
											>
												{[
													record.branch,
													record.department,
													record.costCenter,
												]
													.filter(
														(item) =>
															item &&
															!invalidText(item)
													)
													.join(' • ')}
											</div>
										</div>
									)}
								/>
								<Column
									title="Job Grade"
									key="jobGrade"
									className="bg-white"
									width={120}
									render={(_, record: any) => (
										// <Tag color={record.tagColor}>
										<>
											{invalidText(record.jobGrade)
												? '-'
												: record.jobGrade}
										</>
										// </Tag>
									)}
								/>
							</Table>
						</div>
						<div className={styles['table-footer-buttons']}>
							{selectedRowKeys.length > 0 ? (
								<Button
									size="small"
									onClick={() => setSelectedRowKeys([])}
								>
									Clear Selection
								</Button>
							) : (
								<p></p>
							)}{' '}
							{isAdd && (
								<Button
									type="primary"
									size="small"
									loading={isAssignLoading}
									onClick={handleAssignSelected}
								>
									Assign Selected ({selectedRowKeys.length})
								</Button>
							)}
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default MappingTable;
